import { z } from 'zod'

import { WebSocketEvents } from 'constants/WebSockets'
import { LabelSchema, LabelStrategySchema, type Label } from 'shared/api/requests/chat/schemas'
import { SocketEventBaseSchema } from 'utils/services/notificationsService/constants'

export interface LabelsState {
  selectedLabelId: number | null
  isModalOpen: boolean
  modalLabelId: number | null
  items: Label[]
  isFetching: boolean
  error: string | null
  assignmentIdsInProgress: number[]
  isUpdating: boolean
  isDeleting: boolean
  isCreating: boolean
}

export const LabelCreatedEventSchema = SocketEventBaseSchema.extend({
  event: z.literal(WebSocketEvents.LABEL_CREATED),
  model: LabelSchema,
})

export const LabelUpdatedEventSchema = SocketEventBaseSchema.extend({
  event: z.literal(WebSocketEvents.LABEL_UPDATED),
  model: LabelSchema,
})

export const LabelDeletedEventSchema = SocketEventBaseSchema.extend({
  event: z.literal(WebSocketEvents.LABEL_DELETED),
  id: z.number(),
})

export const LabelAssignmentFinishedEventSchema = SocketEventBaseSchema.extend({
  event: z.literal(WebSocketEvents.LABEL_ASSIGNMENT_FINISHED),
  label_id: z.number(),
  strategy: LabelStrategySchema,
})
export const LabelAssignmentStartedEventSchema = SocketEventBaseSchema.extend({
  event: z.literal(WebSocketEvents.LABEL_ASSIGNMENT_STARTED),
  label_id: z.number(),
})
